export default "__VITE_ASSET__6bb500a3__"